<template>
  <div class="comments-list__card-header">
    <el-link class="link-flex" :href="comment.post.author_url" :underline="false" target="_blank">
      <div class="link-wrap">
        <i class="fas fa-users"></i>
        <span class="comments-list__card-header--author">{{comment.post.author}}</span>

        <div class="comments-list__card-header--date">
          <i class="far fa-calendar-alt"></i>
          <ul class="comments-list__card-header--created">
            <li class="comments-list__card-header--created-date">
              {{getPostDate(comment.post)}}
            </li>
            <li class="comments-list__card-header--created-date">
              {{getPostTime(comment.post)}}
            </li>
          </ul>
        </div>
      </div>
    </el-link>

    <div class="post-comment-social">
      <ul class="post-comment-social-list">
        <li class="post-comment-social-list__item">
          <img src="../../../../../../assets/img/favorite.svg" alt="">
          <p>{{comment.post.likes}}</p>
        </li>
        <li class="post-social-list__item">
          <img src="../../../../../../assets/img/reply.svg" alt="">
          {{comment.post.reposts}}
        </li>
        <li class="post-social-list__item">
          <img src="../../../../../../assets/img/mode_comment.svg" alt="">
          {{comment.post.comments}}
        </li>
        <li class="post-social-list__item">
          <img src="../../../../../../assets/img/visibility.svg" alt="">
          {{comment.post.viewed}}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  // library
  import moment from 'moment';

  export default {
    name: "CommentListHeader",
    props: {
      comment: {
        type: Object
      }
    },
    methods: {
      getPostDate(post) {
        return moment(post.created_date).format("DD.MM.YY");
      },
      getPostTime(post) {
        return moment(post.created_date).format("HH:mm:ss");
      },
    }
  };
</script>

<style>
  .comments-list__card-header {
    display: flex;
  }
  .comments-list__card-header a {
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 14px;
  }
  .comments-list__card-header--author {
    display: inline-block;
    margin-left: 10px;
  }
  .comments-list__card-header--date {
    display: flex;
    margin-left: 15px;
    align-items: center;
  }
  .comments-list__card-header--created {
    padding: 0;
    margin: 0 0 0 10px;
    list-style: none;
    display: flex;
  }
  .comments-list__card-header--created-date {
    margin-right: 15px;
  }
  .link-wrap {
    display: flex;
    align-items: center;
  }
  .post-comment-social {
    margin-left: auto;
  }
  .post-comment-social-list {
    width: 250px;
    display: flex;
    justify-content: space-between;
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .post-comment-social-list__item {
    display: flex;
    align-items: center;
    font-family: "Roboto", "Arial", sans-serif;
    font-weight: 500;
    font-size: 12px;
    margin-right: 20px;
  }
  .post-comment-social-list__item img {
    margin-right: 5px;
  }
  .post-comment-social-list__item:last-child {
    margin-right: 0;
  }
  @media screen and (max-width: 480px) {
    .comments-list__card-header {
      flex-direction: column;
      align-items: flex-start;
    }
    .post-comment-social {
      margin-left: 0;
    }
    .link-flex {
      margin-bottom: 10px;
    }
  }
</style>
